import { render } from "./AppointmentPass.vue?vue&type=template&id=71ee5bdc"
import script from "./AppointmentPass.vue?vue&type=script&lang=js"
export * from "./AppointmentPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__